<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [useTitleBorder]="false"
                                id="ms"
                                size="xl"
                                title="Werkgeversinstellingen">

  <snelstart-ui-dialog-body [padding]="0">
    <snelstart-ui-tab>
      <snelstart-ui-tab-item
        (click)="onSelectTab(0)"
        [isActive]="selectedTab === 0"
        id="firstTab">
        Algemeen
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(1)"
        [isActive]="selectedTab === 1"
        id="secondTab"
      >Instellingen
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(2)"
        [isActive]="selectedTab === 2"
        id="thirdTab"
      >Loonjournaal
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(4)"
        [isActive]="selectedTab === 4"
        id="fourthTab"
      >Toelichting
      </snelstart-ui-tab-item>
    </snelstart-ui-tab>

    <snelstart-ui-tab-content>
      @if (selectedTab === 0) {
        <div [formGroup]="werkgeverFg">
          <div formGroupName="werkgeverGegevens">
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            class="me-1 custom-input-250 custom-readonly"
                                            formControlName="naamWerkgever"
                                            id="naamWerkgever"
                                            label="Naam inhoudingsplichtige">
            </snelstart-ui-text-form-control>
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            class="me-1 custom-input-250 custom-readonly"
                                            formControlName="loonheffingennummer"
                                            id="loonheffingennummer"
                                            label="Loonheffingennummer">
            </snelstart-ui-text-form-control>
            <snelstart-ui-select-form-control (change)="saveForm()"
                                              [options]="optionsTijdvak"
                                              class="me-1 custom-input-250"
                                              formControlName="aangifteTijdvak"
                                              id="aangifteTijdvak"
                                              label="Aangiftetijdvak">
            </snelstart-ui-select-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [maxValue]="168"
                                              [minValue]="1"
                                              class="me-1 custom-input-250"
                                              formControlName="normuren"
                                              id="normuren"
                                              label="Normuren per week">
            </snelstart-ui-number-form-control>
          </div>
        </div>
      }

      @if (selectedTab === 1) {
        <snelstart-ui-alert type="info">
          Met deze versie van de module SnelStart Salaris kun je salarisberekeningen maken voor werkgevers waarop
          <b>geen CAO</b> van toepassing is. Deze mogelijkheid komt later beschikbaar.
        </snelstart-ui-alert>

        <form [formGroup]="settingsFg">
          <div formArrayName="settings">
            <div *ngFor="let item of settings.controls; let i = index; trackBy: trackByFn" [formGroupName]="i">
              <div class="row mb-0.5">
                <div class="col-auto" formGroupName="periode">
                  <snelstart-ui-date-form-control (change)="saveForm()"
                                                  [disabledControl]="true"
                                                  [label]="i === 0 ? 'Ingangsdatum' : ''"
                                                  class="custom-input-150"
                                                  formControlName="begindatum"
                                                  id="begindatum">
                  </snelstart-ui-date-form-control>
                </div>

                <div class="col-auto">
                  <snelstart-ui-select-form-control
                    (change)="saveForm()"
                    [disabledControl]="settings.at(i).getRawValue().periode.einddatum"
                    [label]="i === 0 ? 'CAO code loonaangifte' : ''"
                    [options]="optionsCao"
                    class="custom-input-150"
                    formControlName="caoCode"
                    id="caoCode">
                  </snelstart-ui-select-form-control>
                </div>

                <div class="col-auto">
                  <snelstart-ui-select-form-control
                    (change)="saveForm()"
                    [disabledControl]="settings.at(i).getRawValue().periode.einddatum"
                    [label]="i === 0 ? 'Sectorcode' : ''"
                    [options]="optionsSector"
                    class="custom-input-150"
                    formControlName="sectorCode"
                    id="sectorCode">
                  </snelstart-ui-select-form-control>
                </div>

                <div class="col-auto">
                  <snelstart-ui-select-form-control
                    (change)="saveForm()"
                    [disabledControl]="settings.at(i).getRawValue().periode.einddatum"
                    [label]="i === 0 ? 'AOF indeling' : ''"
                    [options]="optionsAof"
                    class="custom-input-150"
                    formControlName="kleineWerkgever"
                    id="kleineWerkgever">
                  </snelstart-ui-select-form-control>
                </div>

                <div class="col-auto">
                  <snelstart-ui-number-form-control
                    [label]="i === 0 ? 'Whk % verrekenen' : ''"
                    class="custom-input-115"
                    formControlName="whkPercentageWgaVerrekenen"
                    prefix="%"
                    [align]="right"
                    [minValue]="0"
                    [maxValue]="50"
                    id="whkPercentageWgaVerrekenen">
                  </snelstart-ui-number-form-control>
                </div>

                <div class="col-auto">
                  <snelstart-ui-number-form-control
                    [disabledControl]="true"
                    [label]="i === 0 ? 'WGA' : ''"
                    class="custom-input-115"
                    formControlName="whkPercentageWga"
                    prefix="%"
                    [align]="right"
                    id="whkPercentageWga">
                  </snelstart-ui-number-form-control>
                </div>

                <div class="col-auto">
                  <snelstart-ui-number-form-control
                    [disabledControl]="true"
                   [label]="i === 0 ? 'ZW-flex' : ''"
                    class="custom-input-115"
                    formControlName="whkPercentageZw"
                    [align]="right"
                    prefix="%"
                    id="whkPercentageZw">
                  </snelstart-ui-number-form-control>
                </div>

                <!--                  <div formGroupName="periode" class="col-auto">-->
                <!--                    <snelstart-ui-date-form-control (change)="checkEinddatum(); saveForm()"-->
                <!--                                                    [disabledControl]="settings.at(i).getRawValue().periode.einddatum"-->
                <!--                                                    [label]="i === 0 ? 'Einddatum' : ''"-->
                <!--                                                    class="custom-input-150"-->
                <!--                                                    formControlName="einddatum"-->
                <!--                                                    id="einddatum">-->
                <!--                    </snelstart-ui-date-form-control>-->
                <!--                  </div>-->

<!--                <div class="col-auto">-->
<!--                  @if (showDeleteButtonSettings(i)) {-->
<!--                    <snelstart-ui-button-->
<!--                      (click)="verwijderRijSettings(i)"-->
<!--                      [class]="i === 0 ? 'firstrowbutton' : ''"-->
<!--                      icon="trash"-->
<!--                      iconType="light"-->
<!--                      id="buttonDelete"-->
<!--                      size="medium"-->
<!--                      type="secondary">-->
<!--                    </snelstart-ui-button>-->
<!--                  }-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </form>

        @if (hasEinddatum) {
          <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelA"
                               type="link">Nieuwe instellingen
          </snelstart-ui-button>
        }
      }

      @if (selectedTab === 2) {
        <div class="pt-2 pb-3" style="width: 75%">
          <snelstart-ui-alert type="info">
            Met deze versie van de module SnelStart Salaris kun je per aangiftetijdvak een loonjournaalpost
            exporteren. <br/>Onderstaand kun je per looncomponent aangeven welk grootboeknummer van
            toepassing is. De vooringevulde grootboeknummers komen uit het standaardrekeningschema in SnelStart
            boekhouding.
            <br/><br/>
            Als er een <b>SnelStart-administratie</b> is gekoppeld (via de klantinstellingen), dan kan de
            loonjournaalpost direct geëxporteerd worden naar de administratie.
          </snelstart-ui-alert>
        </div>

        <form [formGroup]="grootboeksettingsFg">
          <div formArrayName="grootboeksettings">
            <div *ngFor="let item of grootboeksettings.controls; let i = index; trackBy: trackByFn"
                 [formGroupName]="i"
                 class="d-flex align-items-start gap-0 mb-1">
              <div style="width:300px">
                <snelstart-ui-text-form-control
                  [disabledControl]="true"
                  [label]="i === 0 ? 'Grootboekomschrijving' : ''"
                  class="w-100"
                  formControlName="grootboeknaam"
                  id="grootboeknaam">
                </snelstart-ui-text-form-control>
              </div>
              <div style="width:150px">
                <snelstart-ui-text-form-control
                  (change)="saveForm()"
                  [label]="i === 0 ? 'Grootboeknummer' : ''"
                  class="w-100"
                  formControlName="grootboeknummer"
                  id="grootboeknummer">
                </snelstart-ui-text-form-control>
              </div>

            </div>
          </div>
        </form>
      }

      @if (selectedTab === 4) {
        <div class="accordion" id="informatieAccordion" style="margin-top: -20px">

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingNormuren">
              <button aria-controls="collapseNormuren" aria-expanded="false" class="accordion-button collapsed"
                      data-bs-target="#collapseNormuren" data-bs-toggle="collapse"
                      type="button">
                Algemeen
              </button>
            </h2>
            <div aria-labelledby="headingNormuren" class="accordion-collapse collapse"
                 data-bs-parent="#informatieAccordion"
                 id="collapseNormuren">
              <div class="accordion-body">
                <b>Naam inhoudingsplichtige en loonheffingennummer</b><br/>
                De naam van de inhoudingsplichtige (werkgever) en het loonheffingennummer worden
                overgenomen van de gegevens bij de 'Klantinstellingen'. Je vindt de 'Klantinstellingen'
                op het overzicht van al je klanten (<i>klik op de drie puntjes aan het eind van regel bij
                elke klant</i>).

                <div class="space20"></div>

                <b>Aangiftetijdvak loonheffingen</b><br/>
                Het aangiftetijdvak voor de loonheffingen is de periode waarover een werkgever
                loonheffingen (loonbelasting/premie volksverzekeringen, premies werknemersverzekeringen
                en de inkomensafhankelijke bijdrage Zorgverzekeringswet) moet berekenen, inhouden en
                afdragen aan de Belastingdienst.

                <div class="space20"></div>

                <p>De Belastingdienst kent de volgende aangiftetijdvakken:</p>
                <ul>
                  <li><strong>Maand</strong> – meest gebruikt; aangifte over elke kalendermaand.</li>
                  <li><strong>Vier weken</strong> – veel gebruikt bij weeklonen; aangifte over elke
                    periode van vier weken (13 keer per jaar).
                  </li>
                  <li><strong>Kwartaal</strong> – geschikt voor kleinere werkgevers met beperkte
                    loonsommen; aangifte over drie kalendermaanden.
                  </li>
                  <li><strong>Jaar</strong> – alleen toegestaan in bijzondere situaties, bijvoorbeeld
                    bij incidentele werkgevers of zeer kleine loonsommen, en na toestemming van de
                    Belastingdienst.
                  </li>
                </ul>

                <snelstart-ui-alert type="warning">Let op! Op dit moment ondersteunt SnelStart Salaris
                  alleen het tijdvak 'Maand'.
                </snelstart-ui-alert>

                <b>Normuren per week</b><br/>
                In de salarisadministratie verwijst "normuren" naar het aantal fulltime uren per week. Dit kan zijn
                vastgelegd in een cao. Valt de werkgever niet onder een cao dan zijn 40 uur, 38 uur en 36 uur de meest
                voorkomende varianten voor wat betreft fulltime uren per week.
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingSectorcode">
              <button aria-controls="collapseSectorcode" aria-expanded="false" class="accordion-button collapsed"
                      data-bs-target="#collapseSectorcode" data-bs-toggle="collapse"
                      type="button">
                Instellingen
              </button>
            </h2>
            <div aria-labelledby="headingSectorcode" class="accordion-collapse collapse"
                 data-bs-parent="#informatieAccordion" id="collapseSectorcode">
              <div class="accordion-body">
                <b>CAO-code loonaangifte</b><br/>
                De CAO-code moet in de loonaangifte worden opgenomen om te zorgen voor een correcte verwerking van de
                gegevens. Als er geen CAO van toepassing is, moet dit ook zo worden aangegeven in de loonaangifte door
                “(9999) Geen CAO van toepassing” te selecteren.
                <div class="space20"></div>
                <b>Sectorcode</b><br/>
                Hier selecteer je de sectorcode die door de belastingdienst is afgegeven. Deze vind je terug op de
                beschikking of is op te vragen bij de belastingdienst. De sectorcode staat ook op de mededeling of
                beschikking gedifferentieerde premie Whk die je ieder jaar ontvangt van de belastingdienst.
                Is er geen sectorcode afgegeven, bijvoorbeeld in het geval van een dga-holding, dan selecteer je
                'Geen sector van toepassing'.
                <div class="space20"></div>
                Belangrijk: het is van essentieel belang dat je de sectorcode aanhoudt die is afgegeven door de
                Belastingdienst. Deze code wordt meegenomen in de periodieke loonaangifte en kan van invloed zijn op de
                hoogte van de gedifferentieerde premie Whk.
                Meer informatie is te vinden in het handboek loonheffingen onder 'Sectoraansluiting'.
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingAOF">
              <button aria-controls="collapseAOF" aria-expanded="false" class="accordion-button collapsed"
                      data-bs-target="#collapseAOF" data-bs-toggle="collapse" type="button">
                Loonjournaal
              </button>
            </h2>
            <div aria-labelledby="headingAOF" class="accordion-collapse collapse" data-bs-parent="#informatieAccordion"
                 id="collapseAOF">
              <div class="accordion-body">
                Op dit moment wordt nog gebruik gemaakt van de Snelstart standaard grootboekschema. De grootboeknummers
                kunnen wel gewijzigd worden. In een volgende versie zullen meer mogelijkheden beschikbaar komen voor het
                inrichten van administratie afhankelijk grootboekschema.
              </div>
            </div>
          </div>
        </div>
      }
    </snelstart-ui-tab-content>
  </snelstart-ui-dialog-body>

  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button (click)="dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel" type="secondary">
      Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button (click)="saveWerkgeversInstellingen()" icon="check" id="save" type="primary">
      Opslaan
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
